module.exports = __webpack_public_path__ + "img/game_pc_id.8717ad78.png";